import * as actions from 'actions/floodControl';

export const defaultState = {
  error: null,
  globalFC: {},
  loading: true,
  saving: false,
};

function convertPayload(payload) {
  const { active, config, filterType, id } = payload;

  return {
    data: [
      {
        active,
        config,
        filterType,
        id,
      },
    ],
  };
}

export default function floodControl(state = defaultState, action) {
  switch (action.type) {
    case actions.LOAD_START:
      return {
        ...state,
        loading: true,
      };
    case actions.LOAD_SUCCESS:
      return {
        ...state,
        globalFC: action.payload,
        loading: false,
      };
    case actions.LOAD_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case actions.SAVE_START:
      return {
        ...state,
        saving: true,
      };
    case actions.SAVE_SUCCESS:
      return {
        ...state,
        globalFC: convertPayload(action.payload),
        saving: false,
      };
    case actions.SAVE_FAIL:
      return {
        ...state,
        saving: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
